<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MAygcg/images/cover.jpg?1685204507433" alt="This image is the cover for the book Gospel Witness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gospel Witness
      </h1>
      <p class="bookDescription body article font2">
        <p>In light of our increasingly post-Christian Western contexts, David Gustafson offers a mission-oriented ecclesiology that moves from missional theory to practices of missional engagement. Introducing “God’s human drama” as a way to explain the gospel within God’s redemptive story, he outlines specific ways for pastors and church leaders to shape a “gospeling” culture within their congregations. Gustafson expertly lays the foundations of and approaches to evangelism that are seminal and apt for the church today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David M. Gustafson, Robert E. Coleman
      </h2>
      
      <p class="authorDescription body article"><B>David M. Gustafson</B> is chair of the mission and evangelism department at Trinity Evangelical Divinity School in Deerfield, Illinois. He is an affiliate docent at Johannelund School of Theology in Uppsala, Sweden, and a fellow of the Billy Graham Center of Evangelism in Wheaton, Illinois. He is also the author of <I>Gospel Witness: Evangelism in Word and Deed.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67a6272f